import { useEffect, useRef } from "react";
import TaskIconPicker from "../TaskIconPicker";

export default function AddTaskModal({
  title,
  setTitle,
  selectedIcon,
  setSelectedIcon,
  priority,
  setPriority,
  samenwerken,
  setSamenwerken,
  zelfNakijken,
  setZelfNakijken,
  feedbackEnabled,
  setFeedbackEnabled,
  audience,
  setAudience,
  groups,
  selectedGroupIds,
  setSelectedGroupIds,
  onAdd,
  onClose,
}) {
  const inputRef = useRef(null);
  const hasGroups = groups && groups.length > 0;

  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 50);
  }, []);

  function handleSubmit(e) {
    e.preventDefault();
    if (!title.trim()) return;

    onAdd();
    setTitle("");
    setSelectedIcon("📘");
    setPriority("required");
    setSamenwerken(false);
    setZelfNakijken(false);
    setFeedbackEnabled(false);
    setAudience("all");
    setSelectedGroupIds([]);
    setTimeout(() => inputRef.current?.focus(), 50);
  }

  function toggleGroup(groupId) {
    setSelectedGroupIds((prev) =>
      prev.includes(groupId)
        ? prev.filter((id) => id !== groupId)
        : [...prev, groupId]
    );
  }

  return (
    <div className="ct-modal-backdrop">
      <div className="ct-modal ct-task-form-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ct-modal-header ct-task-form-header">
          <div className="ct-task-form-heading">
            <h2 className="ct-modal-title">Nieuwe taak</h2>
            <p className="ct-panel-subtitle">Maak een taak voor je klas.</p>
          </div>
          <button type="button" onClick={onClose} className="ct-close-button" aria-label="Sluiten">×</button>
        </div>

        <form onSubmit={handleSubmit} className="ct-task-form">
          <label className="ct-task-title-field">
            <span className="ct-form-label">Titel</span>
            <input
              ref={inputRef}
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="ct-form-input w-full"
              placeholder="Bijv. Rekenen opdracht"
            />
          </label>

          <label className="ct-form-label">Kies een icoontje</label>
          <TaskIconPicker
            selectedIcon={selectedIcon}
            onSelect={(icon) => setSelectedIcon(icon)}
          />

          <div className="ct-task-form-grid">
            <div className="ct-form-section">
              <span className="ct-form-label">Type taak</span>
              <div className="ct-segmented-control">
                <button type="button" className={priority === "required" ? "is-selected" : ""} onClick={() => setPriority("required")}>Moetje</button>
                <button type="button" className={priority === "optional" ? "is-selected" : ""} onClick={() => setPriority("optional")}>Magje</button>
              </div>
            </div>

            <div className="ct-form-section">
              <span className="ct-form-label">Toewijzen aan</span>
              <div className="ct-segmented-control">
                <button type="button" className={audience === "all" ? "is-selected" : ""} onClick={() => setAudience("all")}>Hele klas</button>
                <button type="button" className={audience === "targeted" ? "is-selected" : ""} onClick={() => setAudience("targeted")}>Specifiek</button>
              </div>
            </div>

            {audience === "targeted" && (
              <div className="ct-form-section ct-form-section-wide">
                <p className="ct-form-label">Groepen</p>
                {hasGroups ? (
                  <div className="flex flex-wrap gap-2">
                    {groups.map((group) => {
                      const isSelected = selectedGroupIds.includes(group.id);
                      return (
                        <button
                          key={group.id}
                          type="button"
                          onClick={() => toggleGroup(group.id)}
                          className={`ct-group-choice ${isSelected ? "is-selected" : ""}`}
                        >
                          {group.name}
                        </button>
                      );
                    })}
                  </div>
                ) : (
                  <p className="text-sm text-gray-500 italic">Nog geen groepen.</p>
                )}
              </div>
            )}

            <div className="ct-form-section ct-form-section-wide">
              <span className="ct-form-label">Extra opties</span>
              <div className="ct-toggle-grid">
                <button type="button" className={`ct-toggle-card ${samenwerken ? "is-selected" : ""}`} aria-pressed={samenwerken} onClick={() => setSamenwerken(!samenwerken)}>
                  <span>🤝</span><span>Samenwerken</span><strong>{samenwerken ? "Aan" : "Uit"}</strong>
                </button>
                <button type="button" className={`ct-toggle-card ${zelfNakijken ? "is-selected" : ""}`} aria-pressed={zelfNakijken} onClick={() => setZelfNakijken(!zelfNakijken)}>
                  <span>🔑</span><span>Zelf nakijken</span><strong>{zelfNakijken ? "Aan" : "Uit"}</strong>
                </button>
                <button type="button" className={`ct-toggle-card ${feedbackEnabled ? "is-selected" : ""}`} aria-pressed={feedbackEnabled} onClick={() => setFeedbackEnabled(!feedbackEnabled)}>
                  <span>💬</span><span>Feedback vragen</span><strong>{feedbackEnabled ? "Aan" : "Uit"}</strong>
                </button>
              </div>
            </div>
          </div>

          <div className="flex justify-end space-x-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="ct-button-secondary"
            >
              Sluiten
            </button>

            <button
              type="submit"
              className="ct-button-primary"
            >
              Opslaan
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
